import { render, staticRenderFns } from "./disbursement-widget.vue?vue&type=template&id=9bf1b3f8&"
import script from "./disbursement-widget.vue?vue&type=script&lang=js&"
export * from "./disbursement-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports